module.exports = __webpack_public_path__ + "static/img/partner_org_icon.b3b417eb.png";